import React,{useState,useEffect} from 'react';
// import {ReactComponent as StaffVector} from '../../StaticData/Vectors/staffVector.svg';
import DeleteIcon from '@mui/icons-material/Delete';
// import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useDeleteMission} from '../../Hooks';
import { useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
   
import { Grid, Box, Typography, Button, Tooltip, IconButton, Dialog, DialogActions, DialogTitle, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import StarIcon from '@mui/icons-material/Star';

export const Mission = (props: any) => {
    let { item, setPersonId, setShowEditModal, setPersonIdFDelete, setDeleteState } = props;
    let { name, id } = item;
 // const userId=useSelector((state:any)=>state.loign.userInfo.userId);
 const tenantId:string|null=useSelector((state:any)=>state.meetings.profileTenantId);
 // const userPhoneNumber=useSelector((state:any)=>state.loign.userPhoneNumber);

 // const{mutate:deletePerson,data:deletePersonData,isSuccess:deletePerSuccess}=useDeletePerson();
 const{mutate:deleteMission,data:deleteData,isSuccess}=useDeleteMission();
 // let{setPersonId}=props
 //     setShowToastMessage={setShowToastMessage}
 // setAddStaffState={setUserAsyncOpState}
//  let{item,setPersonId,setShowEditModal,setPersonIdFDelete,actived,setDeleteState}=props;
 // console.log(item)
//  let{name,id}=item;
 // const[imgSrc,setImgSrc]=useState<any>(null);
 const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
 const [isSucces, SetIsSuccess] = useState<boolean>();
 const [tMessage, SetTMessage] = useState<string>();

// const initialEditPerson=(perId:string|null)=>{
// setShowEditModal(true)
// setPersonId(id)
// }

const initialDelete=()=>{
 let invitedPersonBody={
     deletedId:id,
     tenantId:tenantId
 }
 deleteMission(invitedPersonBody)
 handleClos();
}



// // const initialDelete=(id:any)=>{
// //     // activated,id
// //    if (activated) {
// //     let deletePersonBody={
// //         DeletedPersonId:id,
// //         UserId:userId,
// //         TenantId:tenantId
// //     }
// //     console.log(deletePersonBody)
// //     deletePerson(deletePersonBody)
// //    }
// //    else{
// //     let invitedPersonBody={
// //         phoneNumber:phoneNumber,
// //         lastModifiedById:userId,
// //         userId:userId,
// //         tenantId:tenantId

// //     }
// //     // console.log(invitedPersonBody)
// //     deleteInvitedPerson(invitedPersonBody)
// //    }

// //     // console.log(item)

// // }

// // useEffect(() => {

// //     if (deleteInvitedData) {
// //         setShowToastMessage(true)
// //         setDeleteState(deleteInvitedData?.data)
// //     }


// // }, [deleteInvitedData,isSuccess])

// // useEffect(() => {

// //     if (deletePersonData) {
// //         setShowToastMessage(true)
// //         setDeleteState(deletePersonData?.data)
// //     }

useEffect(() => {
 if (deleteData) {
   if (deleteData?.data.isSuccess) {
     // setSuccessAddObjective(isSuccess)
     setShowToastMessage(true);
     SetIsSuccess(true);
     SetTMessage(deleteData?.data.metaData.message);
   } else {
     setShowToastMessage(true);
     SetIsSuccess(false);
     SetTMessage(deleteData?.data.metaData.message);
     // setAddObjError(deleteData?.data);
   }
 }
}, [deleteData]);
// }, [isSuccess,deletePersonData])

// // useEffect(() => {
 
// //     if (item) {
// //       setImgSrc(pictureBase64String)
// //     }
// //       }, [item])

//       const [open, setOpen] = React.useState(false);
//       const theme = useTheme();
//       const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
 
//       const handleClickOpen = () => {
//         setOpen(true);
//       };
 
//       const handleClos = () => {
//         setOpen(false);
//       };
 

//       return (
//         <Box
//             width="100%"
//             maxWidth="1000px" // محدود کردن عرض کارت
//             height="100%"
//             marginY={2}
//             bgcolor={'#D5f7D4'}
//             marginX="auto" // وسط چین کردن کارت از دو طرف
//             borderRadius={3}
//             boxShadow={2}
//             px={2}
//             padding={2}
//         >
  
//             <Grid container  spacing={2} alignItems="center">

//                 <Grid item xs={10}  display="flex" justifyContent="start" alignItems="center">
//                     <Box p={1} pt={2} >
//                         <Typography color={'green'} fontSize={'15px'} fontWeight={900} textAlign="center">
//                             {name}
//                         </Typography>
//                     </Box>
//                 </Grid>
//                 <Grid item xs={2} display="flex" justifyContent="flex-end">
//                     <Tooltip title="ویرایش">
//                         <IconButton onClick={() => initialEditPerson(id)}>
//                             <EditIcon color="primary" />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="حذف">
//                         <IconButton onClick={handleClickOpen}>
//                             <DeleteIcon color="error" />
//                         </IconButton>
//                     </Tooltip>
//                     <Dialog
//                         fullScreen={fullScreen}
//                         open={open}
//                         onClose={handleClos}
//                         aria-labelledby="responsive-dialog-title"
//                     >
//                         <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
//                             {"آیا از حذف اطمینان دارید؟"}
//                         </DialogTitle>
//                         <DialogActions>
//                             <Button autoFocus onClick={handleClos}>
//                                 <Typography color={'red'}> انصراف</Typography>
//                             </Button>
//                             <Button autoFocus>
//                                 <Typography color={'#00387C'}> تایید</Typography>
//                             </Button>
//                         </DialogActions>
//                     </Dialog>
//                 </Grid>
//             </Grid>
//         </Box>
//     );
// };
    const [open, setOpen] = useState(false);
    const [showIcons, setShowIcons] = useState(false); // State برای نمایش یا عدم نمایش آیکون‌ها
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClos = () => {
        setOpen(false);
    };

    const handleNameClick = () => {
        // برای دوبار کلیک
        setShowIcons(!showIcons);
    };

    const initialEditPerson = (perId: string | null) => {
        setShowEditModal(true);
        setPersonId(id);
    };

    return (
        <Box
        width="100%"
        maxWidth="1000px"
        height="100%"
        marginY={2}
        bgcolor={'#D5f7D4'}
        marginX="auto"
        borderRadius={3}
        boxShadow={2}
        px={2}
        padding={2}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={10.5} display="flex" justifyContent="center" alignItems="center">
            <Box p={1} pt={2} onClick={handleNameClick} style={{ cursor: 'pointer' }}>
            <Typography
  color={'green'}
  fontSize={'15px'}
  fontWeight={900}
  textAlign="center"
  sx={{
    fontSize: { xs: '11px', sm: '15px' } // در موبایل فونت کوچکتر، در وب فونت اصلی
  }}
>
  {name}
</Typography>

            </Box>
          </Grid>
          {showIcons && (
            <Grid item xs={1.5} display="flex" justifyContent="flex-end">
              <Tooltip title="ویرایش">
                <IconButton onClick={() => initialEditPerson(id)}>
                  <EditIcon color="primary" />
                </IconButton>
              </Tooltip>
              <Tooltip title="حذف">
                <IconButton onClick={handleClickOpen}>
                  <DeleteIcon color="error" />
                </IconButton>
              </Tooltip>
            </Grid>
          )}
        </Grid>
  
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClos}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
            {"آیا از حذف اطمینان دارید؟"}
          </DialogTitle>
          <DialogActions>
            <Button autoFocus onClick={handleClos}>
              <Typography color={'red'}>انصراف</Typography>
            </Button>
            <Button 
              onClick={() => {
                initialDelete();
                handleClos();
              }}
              autoFocus
            >
              <Typography color={'#00387C'}>تایید</Typography>
            </Button>
          </DialogActions>
        </Dialog>
        
        {showToastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
      </Box>
    );
}